import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { IIncidentUpdateRequestDetails } from "../../../api/Incident/IIncidentUpdateRequestDetails";
import EpaCard from "../../../leap-components/EpaCard";
import EpaField from "../../../leap-components/EpaField";
import EpaFieldHtml from "../../../leap-components/EpaFieldHtml";
import { GetIncidentPageUrl } from "../../routeFactory";

interface IncidentUpdateRequestDetailsProps {
  incidentUpdateRequestDetails: IIncidentUpdateRequestDetails;
}

const IncidentUpdateRequestDetails = ({
  incidentUpdateRequestDetails,
}: IncidentUpdateRequestDetailsProps) => {
  const linkToIncident = incidentUpdateRequestDetails.licenceDetails
    ? GetIncidentPageUrl(
        incidentUpdateRequestDetails.licenceDetails?.licenceprofile_number,
        incidentUpdateRequestDetails.incidentid
      )
    : "about:blank";
  var bodyElements = (
    <div>
      <Row>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Date Submitted by EPA"}
            value={incidentUpdateRequestDetails.datesubmitted}
          />
          {incidentUpdateRequestDetails.incidentDetails && (
            <EpaField
              label={"Related Incident"}
              value={
                <Link to={linkToIncident}>
                  {incidentUpdateRequestDetails.incidentDetails?.reference}
                </Link>
              }
            />
          )}
        </Col>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Licensee Response Due Date"}
            value={incidentUpdateRequestDetails.duedate}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12">
          <EpaFieldHtml
            label={"Instruction / Request from EPA"}
            value={incidentUpdateRequestDetails.request}
            labelClassName={"col-12 col-md-12"}
            valueClassName={"col-12 col-md-12"}
          />
        </Col>
      </Row>
    </div>
  ) as JSX.Element;

  return <EpaCard title={"Incident Update Request"} content={bodyElements} />;
};

export default IncidentUpdateRequestDetails;
